import { render, staticRenderFns } from "./DelEdit.vue?vue&type=template&id=21591a1f&scoped=true"
import script from "./DelEdit.vue?vue&type=script&lang=js"
export * from "./DelEdit.vue?vue&type=script&lang=js"
import style0 from "./DelEdit.vue?vue&type=style&index=0&id=21591a1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21591a1f",
  null
  
)

export default component.exports